module.exports = __webpack_public_path__ + "assets/c1b3bb3ca105a52cecfa912cb3349a9a.mp3";